import { FormikSwitchField } from 'lib/components/formik/FormikSwitchField';
import React from 'react';
import {
  FormProps,
  RowWrapper,
  Section,
  SectionTitle,
} from '../../../components/AdminFormComponents';
import { useAuth } from 'lib/context';
import { useTranslation } from 'react-i18next';

export const ContactCreationSection = (props: FormProps) => {
  const { userData } = useAuth();
  const { t } = useTranslation();
  const { setFieldValue, values } = props;
  const leadsIntegrationActive = userData?.customer.leadsIntegrationActive;
  const entityLabel = leadsIntegrationActive ? t('Customer') : t('contact');
  const sectionTitle = t('{{entity}} Creation', { entity: entityLabel });
  const switchLabel = t('Enable {{entity}} Creation', { entity: entityLabel });

  return (
    <Section>
      <SectionTitle>{sectionTitle}</SectionTitle>
      <RowWrapper>
        <FormikSwitchField
          extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
          name='allowContactCreation'
          label={switchLabel}
          onChange={() => {
            setFieldValue('allowContactCreation', !values.allowContactCreation);
          }}
        />
      </RowWrapper>
    </Section>
  );
};
